/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 *
 * Éxito in-modal del primer hito día 1 (proto primer-hito-venta-turno-v1,
 * opción B). Solo cuando la guía día 1 está en `need_first_sale` — ventas 2+
 * siguen con el toast "Venta registrada".
 */
import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { spacing } from '../../../shared/theme/spacing';
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';
import { VueltiFeliz } from '../../../shared/ui/VueltiFeliz';
import { usePosCheckoutStore, type PosSaleCompleted } from '../../store/usePosCheckoutStore';
import { formatPosMoney } from '../../application/posMoneyFormat';

const money = formatPosMoney;

export function PosCheckoutSuccess({ summary }: { summary: PosSaleCompleted }) {
  const resetCheckout = usePosCheckoutStore((s) => s.resetCheckout);
  return (
    <View style={styles.wrap} testID="pos.checkout.success">
      <VueltiFeliz size={88} testID="pos.checkout.successVuelti" />
      <Text style={styles.title}>Venta cobrada</Text>
      <Text style={styles.amount}>
        {money(summary.total)}
        {summary.methodLabel ? ` · ${summary.methodLabel}` : ''}
      </Text>
      {summary.received > 0 ? (
        <View style={styles.detail} testID="pos.checkout.successDetail">
          <View style={styles.detailRow}>
            <Text style={styles.detailLabel}>Recibido</Text>
            <Text style={styles.detailValue}>{money(summary.received)}</Text>
          </View>
          <View style={styles.detailRow}>
            <Text style={styles.detailLabel}>Vuelto</Text>
            <Text style={styles.detailValue}>{money(summary.change)}</Text>
          </View>
        </View>
      ) : null}
      <Pressable
        style={styles.cta}
        onPress={resetCheckout}
        accessibilityRole="button"
        accessibilityLabel="Listo"
        testID="pos.checkout.successDone"
      >
        <Text style={styles.ctaLabel}>Listo</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    alignItems: 'center',
    gap: spacing.xs,
    paddingVertical: spacing.lg,
    paddingHorizontal: spacing.lg,
  },
  title: {
    fontFamily: ticketFonts.sans,
    fontSize: 18,
    fontWeight: '800',
    color: ticketColors.ink,
  },
  amount: {
    fontFamily: ticketFonts.sans,
    fontSize: 15,
    fontWeight: '700',
    color: ticketColors.brandDeep,
  },
  detail: {
    alignSelf: 'stretch',
    marginTop: spacing.sm,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 12,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    gap: 6,
  },
  detailRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  detailLabel: {
    fontFamily: ticketFonts.sans,
    fontSize: 13,
    color: ticketColors.ink2,
  },
  detailValue: {
    fontFamily: ticketFonts.sans,
    fontSize: 13,
    fontWeight: '700',
    color: ticketColors.ink,
  },
  cta: {
    marginTop: spacing.md,
    backgroundColor: ticketColors.brandPrimary,
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 28,
  },
  ctaLabel: {
    fontFamily: ticketFonts.sans,
    fontSize: 15,
    fontWeight: '700',
    color: ticketColors.goldInk,
  },
});
